export default interface Draftable {
  draft?: boolean;
}
